import {ModuleRouteManifest} from '../types'

export const bapRouteManifest: ModuleRouteManifest = {
  code: 'bap',
  privateRoutes: [
    'bap-project-applications',
    'bap-project-manage',
    'bap-project-definitions',
    'bap-project-reports',
  ],
}
